import React, { useState } from "react";
import { OneColumnPage } from "../../layouts/OneColumnPage";
import RegisterExplanation from "./RegisterExplanation";
import RegisterForm from "./RegisterForm";
import useInfluencerRegistration from "./useInfluencerRegistration";
import { useLocation } from "react-router-dom";
import styles from "../InfluencerLogin/influencerLogin.module.scss";

function InfluencerRegistration() {
  const location = useLocation();
  const {
    error,
    disabled,
    mutationLoading,
    setEmail,
    setPassword,
    username,
    setUsername,
    setName,
    createAccount
  } = useInfluencerRegistration(location);

  const [showPassword, setShowPassword] = useState(false);

  return (
    <OneColumnPage title="Create an Account">
      <div className={styles.mainContainer}>
        <header className={styles.mainHeader}>
          <RegisterExplanation />
        </header>
        <div className={styles.loginForm}>
          <RegisterForm
            error={error}
            disabled={disabled}
            mutationLoading={mutationLoading}
            toggleShowPassword={() => setShowPassword(!showPassword)}
            showPassword={showPassword}
            location={location}
            username={username}
            onNameChange={(e) => setName(e.target.value)}
            onUsernameChange={setUsername}
            onEmailChange={(e) => setEmail(e.target.value)}
            onPasswordChange={(e) => setPassword(e.target.value)}
            onSubmit={createAccount}
          />
        </div>
      </div>
    </OneColumnPage>
  );
}

export default InfluencerRegistration;
